import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.96344 11.8569L12.2643 5.81201C13.3116 4.80724 13.2306 3.02858 12.0857 1.88803C10.9675 0.774333 9.26246 0.697804 8.27697 1.71709L2.14795 8.05618C2.14795 8.05618 3.50566 8.60353 4.45981 9.55398C5.41396 10.5044 5.96344 11.8569 5.96344 11.8569Z"
      fill={props?.fill || 'white'}
      stroke={props?.stroke || '#070F21'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.65519 12.9856L5.96002 11.8628C5.96002 11.8628 5.41177 10.5098 4.45849 9.55852C3.5052 8.60719 2.14798 8.05859 2.14798 8.05859L1.0162 12.3324C0.917597 12.7047 1.28642 13.0818 1.65519 12.9856Z"
      fill={props?.fill || 'white'}
      stroke={props?.stroke || '#070F21'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const EditIcon = memo(ForwardRef);
export default EditIcon;
